export const REQUEST_DELETE_NOTE = "request_delete_note"
export const DELETE_NOTE_SUCCESS = "delete_note_success"
export const DELETE_NOTE_FAILURE = "delete_note_failure"

export const CLEAR_DELETE_NOTE_STATE = "clear_delete_note_state"